import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ColorSample = _resolveComponent("ColorSample")!
  const _component_ToggleButton = _resolveComponent("ToggleButton")!
  const _component_Space = _resolveComponent("Space")!
  const _component_Color = _resolveComponent("Color")!
  const _component_GradientBlock = _resolveComponent("GradientBlock")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode("  <Fieldset label=\"色\">"),
    _createVNode(_component_Space, {
      vertical: "",
      full: ""
    }, {
      default: _withCtx(() => [
        (!_ctx.showDetails)
          ? (_openBlock(), _createBlock(_component_Space, {
              key: 0,
              small: "",
              vertical: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fontcolors, (row) => {
                  return (_openBlock(), _createBlock(_component_Space, {
                    key: row[0],
                    small: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (color) => {
                        return (_openBlock(), _createBlock(_component_ToggleButton, {
                          key: color,
                          size: "smallIcon",
                          name: "文字色",
                          "model-value": _ctx.modelValue,
                          value: color,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ColorSample, { color: color }, null, 8 /* PROPS */, ["color"])
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["model-value", "value"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */))
                }), 128 /* KEYED_FRAGMENT */)),
                _createVNode(_component_Color, {
                  block: "",
                  name: "文字色（カスタム）",
                  "model-value": _ctx.modelValue,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
                }, null, 8 /* PROPS */, ["model-value"])
              ]),
              _: 1 /* STABLE */
            }))
          : (_openBlock(), _createBlock(_component_Color, {
              key: 1,
              block: "",
              name: "文字色",
              "model-value": _ctx.modelValue,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
            }, null, 8 /* PROPS */, ["model-value"])),
        _createVNode(_component_GradientBlock, {
          "show-details": _ctx.showDetails,
          "model-value": _ctx.gradient,
          "base-color": _ctx.modelValue,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:gradient', $event)))
        }, null, 8 /* PROPS */, ["show-details", "model-value", "base-color"])
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode("  </Fieldset>")
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}